/**
 * CTA Button Group for the BuyStack12 component
 */
export default class CtaButtonGroup extends HTMLElement {
  private _disabled = false
  private _minQuantity = 1
  private _loading = false
  private _baseCtaLabel = ''

  constructor() {
    super()
  }

  public get loading() {
    return this._loading
  }

  public set loading(value: boolean) {
    this._loading = value
    this.render()
  }

  public get minQuantity() {
    return this._minQuantity
  }

  public set minQuantity(value: number) {
    this._minQuantity = value
    this.render()
  }

  public get disabled() {
    return this._disabled
  }

  public set disabled(value: boolean) {
    this._disabled = value
    this.render()
  }

  public get disabledCtaLabel() {
    const options = this.minQuantity === 1 ? 'option' : 'options'
    return `Select at least ${this.minQuantity} ${options}`
  }

  public connectedCallback() {
    this.initState()
    this.setupListeners()
  }

  private initState() {
    this._disabled = this.hasAttribute('disabled')
    const ctaLabel = this.querySelector<HTMLElement>('.cta-label')
    this._baseCtaLabel = ctaLabel?.dataset.ctaLabel?.trim() ?? ctaLabel?.textContent?.trim() ?? ''
  }

  private setupListeners() {
    this.onclick = e => this.handleClick(e)
  }

  private handleClick({ target: t }: MouseEvent): void {
    if (t instanceof Element && t.matches('[data-action="checkout"], [data-action="checkout"] *')) {
      this.handleCheckout()
    }
  }

  private handleCheckout() {
    this.dispatchEvent(new CustomEvent('checkout', { bubbles: true }))
  }

  render(): void {
    this.classList.toggle('pointer-events-none', this.disabled)
    this.classList.toggle('opacity-50', this.disabled)
    const btn = this.querySelector('[data-action="checkout"]')
    btn?.toggleAttribute('disabled', this.disabled)
    const disabledLabel = this.querySelector('.disabled-label')
    if (disabledLabel) {
      disabledLabel.textContent = this.disabledCtaLabel
    }
    const ctaLabel = this.querySelector('.cta-label')
    if (ctaLabel) {
      ctaLabel.textContent = this._baseCtaLabel
    }
    const loadingIndicator = this.querySelector('.loading-indicator')
    ctaLabel?.classList.toggle('opacity-0', this.loading)
    disabledLabel?.classList.toggle('opacity-0', this.loading)
    loadingIndicator?.classList.toggle('opacity-0', !this.loading)
  }
}

if (!customElements.get('cta-button-group')) {
  customElements.define('cta-button-group', CtaButtonGroup)
}
